import moment from "moment-timezone";

export function formatDate(date) {
    return moment.tz(moment.utc(date), moment.tz.guess(true)).format("DD.MM.YYYY HH:mm")
}